import { bootstrapApplication } from "@angular/platform-browser";
import * as Sentry from "@sentry/angular";
import { environment } from "./Environments/Environment";
import { appConfig } from "./App/AppConfig";
import { App } from "./App/App";

if (environment.glitchtipDsn) {
  Sentry.init({
    dsn: environment.glitchtipDsn,
    tracesSampleRate: 0,
  });
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
